import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=4e5b3fa5&scoped=true&"
import script from "./alerts.vue?vue&type=script&lang=js&"
export * from "./alerts.vue?vue&type=script&lang=js&"
import style0 from "./alerts.vue?vue&type=style&index=0&id=4e5b3fa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b3fa5",
  null
  
)

component.options.__file = "alerts.vue"
export default component.exports